const layout = {
  row: function (args) {
    let row = document.createElement('div');
    args.id ? (row.id = args.id) : false;
    row.classList.add('row');
    args.classes
      ? args.classes.forEach((classname) => row.classList.add(classname))
      : false;
    try {
      args.elements.forEach((el) => {
        typeof el == 'object'
          ? row.insertAdjacentElement('beforeend', el)
          : row.insertAdjacentHTML('beforeend', el);
      });
    } catch (error) {
      console.error(error);
    }
    return row;
  },
  column: function (args) {
    let column = document.createElement('div');
    args.id ? (column.id = args.id) : false;
    column.classList.add('column');
    args.large
      ? column.classList.add(`large-${args.large}`)
      : column.classList.add(`large-12`);
    args.medium
      ? column.classList.add(`medium-${args.medium}`)
      : column.classList.add(`medium-12`);
    args.small
      ? column.classList.add(`small-${args.small}`)
      : column.classList.add(`small-12`);
    args.classes
      ? args.classes.forEach((classname) => column.classList.add(classname))
      : false;
    try {
      args.elements.forEach((el) => {
        typeof el == 'object'
          ? column.insertAdjacentElement('beforeend', el)
          : column.insertAdjacentHTML('beforeend', el);
      });
    } catch (error) {
      console.error(error);
    }
    return column;
  },
};

export default layout;
